/**
 * 震动反馈（2026-10-02 改造需求「移动端轻量触觉反馈」），用 navigator.vibrate。
 * iPhone 的 Safari 不支持这个接口，借隐藏开关控件出震动的办法 iOS 26.5 起也没了，所以只有安卓会震。
 * 开关按设备记在 localStorage 的 star-sea/haptics，默认开；只在触屏上震。
 * 和声音一样，浏览器要页面先被点过一次才肯震，之前的调用会被忽略。
 */
const KEY = 'star-sea/haptics';

/** 这台设备能震（安卓的触屏浏览器） */
export const canVibrate = typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function' && typeof matchMedia === 'function' && matchMedia('(pointer: coarse)').matches;

let on = read();

function read(): boolean {
  try {
    return localStorage.getItem(KEY) !== '0';
  } catch {
    return true;
  }
}

export const haptics = {
  get enabled(): boolean {
    return on;
  },
  setEnabled(v: boolean): void {
    on = v;
    try {
      localStorage.setItem(KEY, v ? '1' : '0');
    } catch {
      // 浏览器不让存：这次打开时有效
    }
  },
};

function buzz(pattern: number | number[]): void {
  if (!canVibrate || !on) return;
  try {
    navigator.vibrate(pattern);
  } catch {
    // 个别浏览器在页面没被点过时会抛错，当作没震
  }
}

/** 一次心跳：震 40 毫秒、停 100、再震 60（需求原文） */
export const heartbeatBuzz = () => buzz([40, 100, 60]);
/** 拨过一格（轮转转到下一张、面板里翻页）：15 毫秒的轻敲 */
export const tickBuzz = () => buzz(15);
/** 放进回收站：两下往下沉 */
export const sinkBuzz = () => buzz([30, 50, 30]);
/** 入场爆炸：一下重的 */
export const thudBuzz = () => buzz(70);
